import { useEffect } from 'react';
import { actionType, showActionType } from 'config/constants';
import { Checkbox, DialogContentText, FormControlLabel, Grid } from '@material-ui/core';
import { useFormik } from 'formik';
import { usePreferencesFunctions } from 'contexts/PreferencesContext';
import * as yup from 'yup';
import clsx from 'clsx';
import DefaultModal from 'components/DefaultModal';
import useStyles from './styles';

const skipWarningValidationSchema = yup
  .object({
    skipWarning: yup.bool(),
  })
  .defined();

const texts = {
  deactivate: {
    title: 'Désactivation d’une prestation',
    subTitle: 'Attention vous allez désactiver une prestation !',
  },
  delete: {
    title: 'Suppression d’une prestation',
    subTitle: 'Attention vous allez supprimer une prestation !',
  },
};

const getTitle = (modalType, showAction) => {
  switch (showAction) {
    case showActionType.CONFLICT_SELECT:
      return 'Attention';
    default:
      return texts[modalType].title;
  }
};

const getValidationSchema = (showAction) => {
  switch (showAction) {
    case showActionType.CONFLICT_SELECT:
      return null;
    default:
      return skipWarningValidationSchema;
  }
};

function ActionOnActivityModal({ loading, onClose, onConfirm, showAction, modalType }) {
  const classes = useStyles();
  const { changePreference } = usePreferencesFunctions();

  const { handleChange, handleSubmit, resetForm, values } = useFormik({
    initialValues: {
      skipWarning: false,
    },
    validationSchema: getValidationSchema(showAction),
    onSubmit: (values) => {
      if (values.skipWarning) {
        changePreference(`show_${modalType}_activity_warning`, false);
      }

      onConfirm?.(values);
    },
  });

  useEffect(() => {
    resetForm();
  }, [resetForm, showAction]);

  const handleCancelConflict = () => {
    onConfirm({ forceAction: false });
  };

  const handleConfirmConflict = () => {
    onConfirm({ forceAction: true });
  };

  const ConflictSelectAction = () => (
    <Grid container item xs={12}>
      <DialogContentText className={clsx(classes.biggerModalText, classes.primaryText, classes.modalText)}>
        {`Cette prestation a déjà été réservée, si vous continuez celle-ci sera bloquée${
          modalType === actionType.DELETE ? ' et ne sera pas supprimée' : ''
        }.`}
      </DialogContentText>
    </Grid>
  );

  const WarningForm = () => (
    <>
      <Grid container item xs={12} justify="center">
        <DialogContentText className={clsx(classes.biggerModalText, classes.primaryText, classes.modalText)}>
          {texts[modalType].subTitle}
        </DialogContentText>
      </Grid>

      <FormControlLabel
        className={classes.preferenceCheckbox}
        name="skipWarning"
        control={<Checkbox color="primary" name="skipWarning" checked={values.skipWarning} onChange={handleChange} />}
        label="Ne plus afficher cet avertissement"
      />
    </>
  );

  const close = showAction === showActionType.CONFLICT_SELECT ? handleCancelConflict : onClose;
  const title = getTitle(modalType, showAction);
  const submit = showAction === showActionType.CONFLICT_SELECT ? handleConfirmConflict : handleSubmit;

  return (
    <DefaultModal
      className={classes.modal}
      forceConfirm
      loading={loading}
      open={!!showAction}
      title={title}
      onClose={close}
      onConfirm={submit}
      square
    >
      {showAction === showActionType.CONFLICT_SELECT && <ConflictSelectAction />}
      {showAction === showActionType.PREFERENCE_WARNING && <WarningForm />}
    </DefaultModal>
  );
}

export default ActionOnActivityModal;
